module.exports = __webpack_public_path__ + "static/media/27.085edae9.jpg";